// extracted by mini-css-extract-plugin
export default {"referralsOverview":"ReferralUrl_referralsOverview__u3z7Z","referralLink":"ReferralUrl_referralLink__lUc3L"};